import React from 'react';
import PropTypes from 'prop-types';

import List from 'Components/List/List';
import VirtualizedList from 'Containers/VirtualizedList/VirtualizedList';
import UsersListRow from 'Containers/UsersListRow/UsersListRow';
import ListTableHeader from 'Containers/ListTableHeader';
import Loading from 'Components/Loading';

class UsersList extends React.Component {
  constructor(props) {
    super(props);

    this.listRenderer = this.listRenderer.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.props.groupId !== nextProps.groupId ||
      this.props.type !== nextProps.type ||
      this.props.isLoading !== nextProps.isLoading ||
      this.props.list.count !== nextProps.list.count ||
      this.props.list.sortAscending !== nextProps.list.sortAscending ||
      this.props.list.sortColumn !== nextProps.list.sortColumn ||
      this.props.list.filteredIds !== nextProps.list.filteredIds ||
      (nextProps.showTableHeader &&
        this.props.stickyOffset !== nextProps.stickyOffset)
    );
  }

  rowRenderer(row, index) {
    const { list, type, groupType, groupId, rowSize } = this.props;

    return (
      <UsersListRow
        key={`user-${row.id}`}
        id={row.id}
        rowIndex={index}
        rowSize={rowSize}
        data={row}
        columnIds={list.columnIds}
        type={type}
        groupType={groupType}
        groupId={groupId}
        isNew={list.newIds.includes(row.id)}
      />
    );
  }

  listRenderer() {
    const { isLoading, list, virtualized } = this.props;
    if (isLoading) return <Loading type="component" />;

    const ids = list ? list.filteredIds || list.ids : undefined;
    const rows = ids.map(id => ({
      id,
      ...list.data[id],
    }));

    if (virtualized)
      return (
        <VirtualizedList
          itemCount={ids.length}
          itemSize={54}
          renderRow={index => {
            const row = rows[index];
            return this.rowRenderer(row, index);
          }}
        />
      );

    return ids.map((id, index) => {
      const row = list.data[id];
      return this.rowRenderer(row, index);
    });
  }

  render() {
    const {
      type,
      groupType,
      list,
      stickyOffset,
      headerStuck,
      showTableHeader,
      virtualized,
      rowSize,
    } = this.props;
    return (
      <List
        allowXAxisScroll
        groupType={groupType}
        type={type}
        virtualized={virtualized}
        containerHeight={virtualized ? '100vh' : undefined}
      >
        {showTableHeader ? (
          <ListTableHeader
            type={type}
            stickyOffset={stickyOffset}
            headerStuck={headerStuck}
            sortColumn={list.sortColumn}
            rowSize={rowSize}
            columnIds={list.columnIds}
            sortAscending={list.sortAscending}
            listId={list.listId}
          />
        ) : null}
        {this.listRenderer()}
      </List>
    );
  }
}

UsersList.defaultProps = {
  showTableHeader: true,
};

UsersList.propTypes = {
  type: PropTypes.oneOf([
    'students_in_school',
    'students_in_class',
    'teachers_in_school',
  ]).isRequired,
  groupType: PropTypes.oneOf(['school', 'class']).isRequired,
  list: PropTypes.object.isRequired,
  stickyOffset: PropTypes.number,
  headerStuck: PropTypes.bool,
  showTableHeader: PropTypes.bool,
  virtualized: PropTypes.bool,
  isLoading: PropTypes.bool,
  groupId: PropTypes.number,
};

export default UsersList;
